
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/MortgageRules",
      function () {
        return require("private-next-pages/MortgageRules/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/MortgageRules"])
      });
    }
  